export const optOut = {
  // Common
  common: {
    loading: 'Loading...',
    manageAllPreferences: 'Logged in? Manage all preferences',
  },

  // Business type labels
  businessType: {
    restaurants: 'Restaurants',
    shops: 'Shops',
  },

  // Error states
  error: {
    title: 'Something went wrong',
    invalidLink:
      'This link appears to be invalid or has expired. Please try clicking the link in your message again.',
  },

  // Left panel
  sidebar: {
    kicker: 'The best way to order',
    title: 'Get the app',
    description:
      "Your usual basket is one tap away, you can see what's ready before you leave the house, and every order you've made is saved.",
    appStore: 'Download on the App Store',
    googlePlay: 'Get it on Google Play',
  },

  // SMS opt-out flow
  sms: {
    landing: {
      title: 'Order now.',
      summary:
        "You're still subscribed. That link just opened this page. So while you're here, take a look at all our {{businessType}} and deals.",
      browseButton: 'Browse {{businessType}}',
      or: 'or',
      optOutCopy:
        "If you'd rather we didn't message you, that's no problem at all. You can turn them back on in your account if you change your mind.",
      optOutButton: 'Stop marketing texts to {{phone}}',
    },
    confirm: {
      step: 'Step 1 of 2',
      title: 'Stop marketing texts?',
      summary: "Here's exactly what changes for {{phone}}.",
      effects: {
        noOffers: {
          title: 'Offers and promotions texts stop',
          note: 'Roughly four a month.',
        },
        orderUpdates: {
          title: 'Order confirmations continue',
          note: 'Sent when you place an order.',
        },
        deliveryUpdates: {
          title: 'Collection and delivery updates continue',
          note: "You'll still know when food is ready.",
        },
      },
      cancelButton: 'Cancel',
      confirmButton: 'Yes, unsubscribe',
    },
    done: {
      step: 'Done',
      title: 'Marketing texts stopped',
      summary:
        "{{phone}} won't get offers from us. Order updates still come through, and you can turn texts back on any time in your account.",
      undoButton: 'Undo, I changed my mind',
      browseButton: 'Browse {{businessType}}',
    },
  },

  // Email opt-out flow
  email: {
    done: {
      step: 'Done',
      title: 'Marketing emails stopped',
      summary:
        "{{email}} won't get promotional emails from us. Order updates still come through, and you can turn emails back on any time in your account.",
      undoButton: 'Undo, I changed my mind',
      browseButton: 'Browse {{businessType}}',
    },
  },
}
